import { Gtag, Parameters } from '~/types/gtag';
import { UserObjectProps } from '~/types/user';

enum UserType {
  Customer = 'customer',
  Staff = 'staff',
  Betaling = 'betaling',
  Plus = 'plus',
}

const useGtag = () => {
  const getGA4UserType = function getGA4UserType(
    user: UserObjectProps,
  ): UserType {
    let userType: UserType = UserType.Customer;

    if (user.is_staff) {
      userType = UserType.Staff;
    } else if (user.is_betaling) {
      userType = UserType.Betaling;
    } else if (user.has_plus) {
      userType = UserType.Plus;
    }

    return userType;
  };

  // Wrapper for better TS support
  const gtag: Gtag = function gtag(
    command: string,
    value: string | Record<any, any>,
    parameters?: Partial<Parameters>,
  ) {
    if (parameters) {
      // @ts-ignore
      gtagFn(command, value, parameters);
    } else {
      // @ts-ignore
      gtagFn(command, value);
    }
  };

  const gtagFn = function gtagFn() {
    window.dataLayer = window.dataLayer || [];

    // Using the spread operator won't work, so `arguments` is required.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  return {
    gtag,
    gtagFn,
    getGA4UserType,
  };
};

export default useGtag;
